/** 
 *  ==========================
 *  BLOCK: Blog Post Edit
 *  ==========================
 */

/**
 * External dependencies
 */
import {
	AdvancedRangeControl,
	AdvancedSelectControl,
	PostSelector,
	TaxonomyControl,
} from '~cartzillagb/components'
import {
	withUniqueClass,
	withBlockStyles,
	withTabbedInspector
} from '~cartzillagb/higher-order'
import { i18n } from 'cartzillagb'
import classnames from 'classnames'

/**
 * Internal dependencies
 */
import createStyles from './style'
import './common'


/**
 * WordPress dependencies
 */
import {
	Fragment
} from '@wordpress/element'
import { RichText } from '@wordpress/block-editor'
import {
	PanelBody, ToggleControl, BaseControl, Disabled, TextControl
} from '@wordpress/components'
import { __ } from '@wordpress/i18n'
import { applyFilters, addFilter } from '@wordpress/hooks'
import { compose } from '@wordpress/compose'

import Block from './block'

addFilter( 'cartzillagb.blog-post.edit.inspector.style.before', 'cartzillagb/blog-post', ( output, props ) => {
	const {
		attributes,
		setAttributes 
	} = props

	const {
		enableContainer,
		displayPostTitle,
		displayPostContent,
		postsToShow,
		orderBy,
		postperSlide,
		order,
		btnLink,
		posts = [],
		taxonomyType = 'category',
		taxonomy,
	} = attributes

	return (
		<Fragment>
			<PanelBody title={ __( 'General', i18n ) }  initialOpen={ true }>
				<ToggleControl
					label={ __( 'Enable Container ?', i18n ) }
					checked={ enableContainer }
					onChange={ enableContainer => setAttributes( { enableContainer } ) }
				/>
				<ToggleControl
					label={ __( 'Dispaly Title ?', i18n ) }
					checked={ displayPostTitle }
					onChange={ displayPostTitle => setAttributes( { displayPostTitle } ) }
				/>
				<ToggleControl
					label={ __( 'Display Post Content', i18n ) }
					checked={ displayPostContent }
					onChange={ displayPostContent => setAttributes( { displayPostContent } ) }
				/>
				<TextControl
					label={  __( 'Button Link', i18n ) }
					value={ btnLink }
					onChange={ btnLink => setAttributes( { btnLink } ) }
				/>
			</PanelBody>
			<PanelBody title={ __( 'Blog Settings', i18n ) } initialOpen={ false }>
				<AdvancedRangeControl
					label={ __( 'Number of posts', i18n ) }
					value={ postsToShow }
					onChange={ postsToShow => setAttributes( { postsToShow } ) }
					min={ 1 }
					max={ applyFilters( 'cartzillagb.blog-post.post.limit', 15 ) }
					allowReset={ true }
					placeholder="6"
					className="czgb--help-tip-general-shadow"
				/>
				 <AdvancedRangeControl
					label={ __( 'Post per slide', i18n ) }
					value={ postperSlide }
					onChange={ postperSlide => setAttributes( { postperSlide } ) }
					min={ 1 }
					max={ applyFilters( 'cartzillagb.blog-post.post-slide.limit', 3 ) }
					allowReset={ true }
					placeholder="3"
					className="czgb--help-tip-general-shadow"
				/>
				<AdvancedSelectControl
					label={ __( 'Order by', i18n ) }
					options={ [
						{ label: __( 'Newest to Oldest', i18n ), value: 'date,desc' },
						{ label: __( 'Oldest to Newest', i18n ), value: 'date,asc' },
						{ label: __( 'A → Z', i18n ), value: 'title,asc' },
						{ label: __( 'Z → A', i18n ), value: 'title,desc' },
						{ label: __( 'Last Modified to Oldest', i18n ), value: 'modified,desc' },
						{ label: __( 'Oldest Modified to Last', i18n ), value: 'modified,asc' },
						{ label: __( 'Menu Order', i18n ), value: 'menu_order,asc' },
						{ label: __( 'Random', i18n ), value: 'rand,desc' },
					] }
					value={ `${ orderBy },${ order }` }
					onChange={ value => setAttributes( {
						orderBy: value.split( ',' )[ 0 ],
						order: value.split( ',' )[ 1 ],
					} ) }
				/>
				<BaseControl label={ __( 'Select Post', i18n ) } id={ "post" }>
					<PostSelector
						onPostSelect={ post => {
							posts.push(post)
							setAttributes({ posts: [...posts] })
						} }
						posts={ posts }
						onChange={ newValue => {
							setAttributes({ posts: [...newValue] })
						} }
						postType="post"
					/>
				</BaseControl>
				<TaxonomyControl
					taxonomyType={ taxonomyType }
					onChangeTaxonomyType={ taxonomyType => setAttributes( { taxonomyType } ) }
					taxonomy={ taxonomy }
					onChangeTaxonomy={ taxonomy => setAttributes( { taxonomy } ) }
				/>
			</PanelBody>
		</Fragment>
	)
} )

const edit = props => {

	const {
		blockName,
		styles,
		attributes,
		setAttributes,
		className,
	} = props

	const {
		hideMobile,
		hideTablet,
		hideDesktop,
		enableContainer,
		btnText,
		btnIcon,
	} = attributes

	const output = (
		<div className={ classnames( [
			className,
		], {} ) }>
			{ styles }
			<section className={ classnames( [
				'czgb-blog-post',
				'py-5',
			], {
				'czgb--hide-mobile' : hideMobile,
				'czgb--hide-tablet' : hideTablet,
				'czgb--hide-desktop' : hideDesktop,
			} ) }>
				<div className={ classnames( [
					'py-lg-3',
				], {
					'container' : enableContainer
				} ) }>
					{ applyFilters( `cartzillagb.${ blockName }.edit.output.block-title`, null, null, props ) }
					<div className="cz-carousel">
						<Disabled>
							<Block attributes={ { ...attributes } } />
						</Disabled>
					</div>
					<div className="text-center pt-4 mt-md-2">
						<a className="btn btn-outline-accent" href="#anchor">
							<RichText
								tagName="span"
								value={ btnText }
								onChange={ btnText => setAttributes( { btnText } ) }
							/>
							<i className={ classnames( [
								btnIcon,
								'font-size-ms',
								'ml-1',
							], {} ) }></i>
						</a>
					</div>
				</div>
			</section>
		</div>
	)

	return output
}

export default compose(
	withUniqueClass,
	withBlockStyles( createStyles, { editorMode: true } ),
	withTabbedInspector( [ 'style', 'advanced' ] ),
)( edit )
